export async function fetchFileAsBlobUrl(fileUrl: string): Promise<string> {
  try {
    // Fetch the file
    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.statusText}`);
    }

    // Convert the response to a blob
    const blob = await response.blob();

    // Create a URL for the blob
    const blobUrl = URL.createObjectURL(blob);

    return blobUrl;
  } catch (error) {
    console.error('Error fetching file and creating blob URL:', error);
    throw error;
  }
}

/*
// Example usage
fetchFileAsBlobUrl('https://example.com/path/to/file')
  .then(blobUrl => {
    console.log('Blob URL:', blobUrl);
    // You can now use the blob URL, e.g., set it as the src of an image
  })
  .catch(console.error);
*/
export function disposeBlobUrl(blobUrl: string): void {
  try {
    URL.revokeObjectURL(blobUrl);
    console.log(`Blob URL disposed: ${blobUrl}`);
  } catch (error) {
    console.error('Error disposing blob URL:', error);
  }
}

/*
// Example usage
const blobUrl = 'blob:http://example.com/12345';
disposeBlobUrl(blobUrl);
*/

/** Saves a blob through the browser's download, under the given file name. */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  // Revoked later rather than at once, so the browser has started the download.
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
